/**
 * CSV para Excel em pt-BR: separador ";", CRLF, BOM UTF-8, aspas quando preciso.
 * Células de texto que começam com = + - @ recebem apóstrofo (injeção de fórmula).
 */

export type CsvValue = string | number | boolean | null | undefined;

export interface CsvColumn<Row> {
  header: string;
  value: (row: Row) => CsvValue;
}

function cell(v: CsvValue): string {
  if (v === null || v === undefined) return "";
  let s = typeof v === "number" ? String(v).replace(".", ",") : typeof v === "boolean" ? (v ? "sim" : "não") : v;
  if (typeof v === "string" && /^[=+\-@\t\r]/.test(s) && !/^-?\d+(,\d+)?$/.test(s)) s = `'${s}`;
  return /[;"\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function toCsv<Row>(rows: Row[], columns: CsvColumn<Row>[]): string {
  const lines = [columns.map((c) => cell(c.header)).join(";")];
  for (const r of rows) lines.push(columns.map((c) => cell(c.value(r))).join(";"));
  return `﻿${lines.join("\r\n")}\r\n`;
}

export function downloadText(filename: string, text: string, mime = "text/csv;charset=utf-8"): void {
  const blob = new Blob([text], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
